import PortcoComponent from "@/components/deals/portco";

export default function Portco() {
  return <PortcoComponent />;
}
